module.exports = __webpack_public_path__ + "img/Mitsui-Auto-Finance.2cde7df6.svg";